import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import TitleBar from "../Layout/titleBar";
import { Row, Col } from "react-flexbox-grid";
import MyDialog from "../Layout/myDialog";
import "./rubros.css";
import Item from "./itemRubro";
import { sagaGetRubros } from "../../reducers/rubrosReducer/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const RubroListado = (props) => {
  const { rubros, mapToItem } = props;

  const dragItem = useRef();
  const dragOverItem = useRef();
  const [itemsRubros, setItemsRubros] = useState([]);

  React.useEffect(() => {
    setItemsRubros(
      rubros.map((x) => ({
        idRubro: x.idRubro,
        nombre: x.nombre,
        imagen: x.imagen,
        opciones: mapToItem(x).opciones,
        activo: x.activo,
      }))
    );
  }, [rubros, mapToItem]);

  const dragStart = (position) => {
    dragItem.current = position;
    //console.log(e.target.innerHTML);
  };

  const dragEnter = (position) => {
    dragOverItem.current = position;
    //console.log(e.target.innerHTML);
  };

  const drop = () => {
    const copyListItems = [...itemsRubros];
    const dragItemContent = copyListItems[dragItem.current];
    const dragOverItemContent = copyListItems[dragOverItem.current];
    copyListItems.splice(dragItem.current, 1); //se borra
    copyListItems.splice(dragItem.current, 0, dragOverItemContent);
    copyListItems.splice(dragOverItem.current, 1); //se borra
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;

    props.handleOnSwap(
      copyListItems.map((x) => x.idRubro.toString()),
      props.canSwap
    );

    setItemsRubros(copyListItems);
  };

  return (
    <>
      {/* menú superior */}
      <TitleBar
        title={"Rubros"}
        handleOnSearch={props.handleOnSearch}
        searchPlaceholder="Rubro"
        showSearch={true}
        newButtonLink="/Rubros/Edit/0"
        validator="nombre"
      />

      <Row style={{ margin: "0px" }} className="draggable">
        {itemsRubros &&
          itemsRubros.map((item, index) => (
            <Col
              md={6}
              lg={4}
              onDragStart={() => dragStart(index)}
              onDragEnter={() => dragEnter(index)}
              onDragEnd={drop}
              key={index}
              className="draggable"
              draggable
            >
              <Item item={item} {...props}></Item>
            </Col>
          ))}
      </Row>
      {(props.rubros === undefined || props.rubros.length === 0 || itemsRubros.length === 0) && (
        <div className="noRubros">No se encontraron rubros activos</div>
      )}
      {props.openModal && (
        <MyDialog
          cuerpo={props.mensaje}
          botonConfirmar={props.labelModalOk}
          handleOnConfirmar={() => {
            props.handleModalOk();
            setTimeout(props.handleOnSearch, 600);
          }}
          handleOnCancelar={props.handleCloseModal}
        />
      )}
    </>
  );
};

RubroListado.propTypes = {
  rubros: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnSave: PropTypes.func.isRequired,
  handleOnSearch: PropTypes.func.isRequired,
  canSwap: PropTypes.bool,
  mensaje: PropTypes.string,
  labelModalOk: PropTypes.string,
  handleModalOk: PropTypes.func,
  handleCloseModal: PropTypes.func,
  openModal: PropTypes.bool,
};

RubroListado.defaultProps = {
  rubros: [],
  canSwap: true,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetRubros,
    },
    dispatch
  );
}

export default connect(mapDispatchToProps)(RubroListado);
